var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.66669C4.36364 2.66669 1.25818 4.92851 0 8.12123C1.25818 11.314 4.36364 13.5758 8 13.5758C11.6364 13.5758 14.7418 11.314 16 8.12123C14.7418 4.92851 11.6364 2.66669 8 2.66669ZM8 11.7576C5.99273 11.7576 4.36364 10.1285 4.36364 8.12123C4.36364 6.11396 5.99273 4.48487 8 4.48487C10.0073 4.48487 11.6364 6.11396 11.6364 8.12123C11.6364 10.1285 10.0073 11.7576 8 11.7576ZM8 5.93941C6.79273 5.93941 5.81818 6.91396 5.81818 8.12123C5.81818 9.32851 6.79273 10.3031 8 10.3031C9.20727 10.3031 10.1818 9.32851 10.1818 8.12123C10.1818 6.91396 9.20727 5.93941 8 5.93941Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.040b2eef0dcc3fea6647d8d5f38ea437.svg";
export { ForwardRef as ReactComponent };